<template>
  <div>
    <BaseDialog title="模板设置" :showVisible="isShow" @close="isShow = false" size="EXTRA_LARGE" class="invoiceTemplate"
      :isCancel="false" :isConfirm="false">
      <template v-slot:content>
        <div class="invoiceTemplate__wrap">
          <div class='item_comtainer clearfix'>
            <div class='item_comtainer_item fl' v-for='i in templateList' :key='i.id'>
              <div class='item_title'>{{ i.name }}</div>
              <div class='addTemplate' v-if='i.isFirst' @click='handleClickAddTemplete'>
                <span>
                  <i class='el-icon-plus'></i>
                </span>
              </div>
              <div class='item_pre' v-else>
                <div v-for='(item, index) in i.invoiceVoucherAddendumTemList' :key='item.id' class='subject_item'
                  :title='item.textShow' v-if='index < 3'>
                  {{ i.invoiceVoucherAddendumTemList.length > 3 && index === 2 ? "..." : item.textShow }}
                </div>
                <div class='operation_s'>
                  <span style='color: #268AFF;' @click='handleOperationItem({...i,isCopy:true})'>复制</span>
                  <span style='color: #268AFF;margin-left: 15px;' @click='handleOperationItem(i)'>编辑</span>
                  <span style='color: #FF6010;margin-left: 15px;' @click='handleDeleteItem(i)'>删除</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </BaseDialog>
    <add-template :AddInvoiceTemplateDialogShow.sync='AddInvoiceTemplateDialogShow' @successSave='successSave'
      :nowRow='nowRow'>
    </add-template>
  </div>
</template>
<script>
import AddTemplate from '@/components/dialog/AddInvoiceTemplate'
import BaseDialog from '@/components/dialog/BaseDialog.vue';
export default {
  props: {
    invoiceTemplateShow: Boolean

  },
  components: {
    AddTemplate, BaseDialog
  },
  data() {
    return {
      nowRow: {},     // 当前操作模板
      AddInvoiceTemplateDialogShow: false,     // 新增模板
      loading: false,
      templateList: [],
    }
  },
  created() {

    this.getInvoiceVoucherTemplate();
  },
  computed: {
    // 显示弹窗
    isShow: {
      get() {
        return this.invoiceTemplateShow;
      },
      set(val) {
        this.$emit('update:invoiceTemplateShow', val);
      }
    },
  },
  methods: {
    // 查询下拉框模板
    getInvoiceVoucherTemplate() {
      this.$http.post('InvoiceVoucherTemplateController/getAllTemplate', {}).then(res => {
        if (res && res.data.code == 1) {
          this.voucherTemplateList = res.data.data;

          this.$emit("voucherTemplateLists", res.data.data)
        }
      })
    },
    // 编辑
    handleOperationItem(row) {
      this.AddInvoiceTemplateDialogShow = true;
      this.nowRow = row;
    },
    // 删除
    handleDeleteItem(row) {
      if (!row) {
        return this.$message.error("未检测到模板！")
      }
      this.$confirm(`是否删除名字为 ${row.name} 的凭证模板?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('InvoiceVoucherTemplateController/delVoucherTemplate', { temId: row.id }).then(res => {
          if (res && res.data.code == 1) {
            this.$message.success("删除成功！");
            this.getTempleteList();
            this.getInvoiceVoucherTemplate();
          }
        })

      }).catch(() => {

      });
    },
    //新增模板
    handleClickAddTemplete() {
      this.AddInvoiceTemplateDialogShow = true;
      this.nowRow = {};
    },
    // 保存成功返回
    successSave(data) {
      this.getTempleteList();
      this.getInvoiceVoucherTemplate();
    },
    //查询模板
    getTempleteList() {

      this.loading = true;
      this.$http.post('InvoiceVoucherTemplateController/allTemplateList', {}).then(res => {
        this.templateList = [];
        this.loading = false;
        let datas = []
        if (res && res.data.code == 1) {
          datas = res.data.data.map(i => {
            if(i.invoiceVoucherAddendumTemList) {
              i.invoiceVoucherAddendumTemList.forEach((j, index) => {
                j.textShow = j.creditDirection + "：" + j.summary + (j.invoiceValue == 1 ? "（税额）" : j.invoiceValue == 2 ? "（价税合计）" : "（不含税金额）");
              })
            }

            // if(i.invoiceVoucherAddendumTemList.length>3) {
            //    	i.invoiceVoucherAddendumTemList.splice(3);
            //    	i.invoiceVoucherAddendumTemList[2].textShow = "..."
            //    }
            return i;
          });

        }
        datas.unshift({
          name: "新增模板",
          id: 1,
          isFirst: true
        })

        this.templateList = datas;
      })

    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.getTempleteList();
      }
    }
  }
}
</script>
<style lang='less' scoped>
@import "./style/invoiceTemplate.less";
</style>



// WEBPACK FOOTER //
// src/components/dialog/invoiceTemplate.vue